import { CertificateProps } from "src/types/type";

export const certificateData: CertificateProps[] = [
  {
    name: "IA para quem programa de verdade",
    institute: "curso.dev",
    conclusion: "2026",
    isRelevant: true,
    inProgress: true,
  },
  {
    name: "Desenvolvimento Web",
    institute: "curso.dev",
    duration: "81",
    conclusion: "2026",
    link: "pdf/Certificado · leoFagundes · curso.dev.pdf",
    isRelevant: true,
    inProgress: true,
  },
  {
    name: "Python Impressionador",
    institute: "Hashtag Treinamentos",
    duration: "179",
    conclusion: "2022",
    link: "pdf/Certificado-Hashtah_Treinamentos-Python_Impressionador.pdf",
    isRelevant: true,
  },
  {
    name: "Certificado CC50 Ciência da Computação",
    institute: "CC50",
    duration: "70",
    conclusion: "2022",
    link: "pdf/Certificado-CC50-Ciencia_da_computaçao.pdf",
    isRelevant: true,
  },
  {
    name: "Node.js: Api REST com Express e MongoDB",
    institute: "Alura",
    duration: "10",
    conclusion: "2024",
    link: "pdf/Certificado-Alura-Node.js_com_Express_e_MongoDB.pdf",
  },
  {
    name: "React: Projeto Full Stack",
    institute: "Alura",
    duration: "12",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-React_projeto_full_stack.pdf",
  },
  {
    name: "React: Desenvolvendo com JavaScript",
    institute: "Alura",
    duration: "14",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-React_JavaScript.pdf",
  },
  {
    name: "React: Desenvolvendo com Typescript",
    institute: "Alura",
    duration: "12",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-React_Typescript.pdf",
  },
  {
    name: "Tailwind CSS",
    institute: "Alura",
    duration: "8",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-Tailwind.pdf",
  },
  {
    name: "Flexbox e Layouts Responsivos",
    institute: "Alura",
    duration: "6",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-Flexbox.pdf",
  },
  {
    name: "Git e GitHub",
    institute: "Alura",
    duration: "8",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-Git_e_GitHub.pdf",
  },
  {
    name: "JavaScript para Web",
    institute: "Alura",
    duration: "10",
    conclusion: "2023",
    link: "pdf/Certificado-Alura-JavaScript.pdf",
  },
  {
    name: "Curso em vídeo - Python 3",
    institute: "Curso em Vídeo",
    duration: "40",
    conclusion: "2022",
    link: "pdf/Certificado-Curso_em_video-Python_Mundo_1.pdf",
  },
  {
    name: "Excel Intermediário",
    institute: "Dytz informática",
    duration: "20",
    conclusion: "2022",
    link: "pdf/Certificado-Dytz_informática-Excel.pdf",
  },

  {
    name: "LAC4 - Segurança da informação",
    institute: "GSI",
    duration: "8",
    conclusion: "2023",
    link: "pdf/Certificado-LAC4-Segurança_da_informação.pdf",
  },
  {
    name: "Rocketseat: NLW Journey",
    institute: "Rocketseat",
    duration: "4",
    conclusion: "2024",
    link: "pdf/Certificado-Rocketseat-NLW_Journey.pdf",
  },
];
